export const PREFERRED_FOOT = ['Both', 'Left', 'Right'];
